<select class="ScrollMenu Input" v-model="selectedLabel">
    <option v-for="(label,index) in jumpLabels" :value="label">{{label.getAttribute("data-jump-label")}}</option>
</select>